import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import * as breakpoint from '@pixelunion/breakpoint';
import SiteOverlay from './SiteOverlay';
import ScrollLock from '../helpers/ScrollLock';

export default class SearchFlyout {
  constructor(el, settings) {
    this.el = el;
    this.settings = settings;
    this.events = new EventHandler();
    this.siteOverlay = new SiteOverlay();

    this.header = document.querySelector('[data-site-header]');
    this.headerContainer = document.querySelector('[data-site-header-container]');
    this.headerControls = document.querySelector('[data-header-controls]');

    this.input = this.el.querySelector('[data-search-input]');
    this.close = this.el.querySelector('[data-search-flyout-close]');
    this.formOffset = this.close.offsetWidth;
    this.animation = transition({ el: this.el, state: 'closed' });

    this.isOpen = false;

    this.events.register(window, 'keyup', e => this._onKeyUp(e));
    this.events.register(this.close, 'click', () => this._close());
    this.events.register(this.close, 'blur', () => this._close());

    breakpoint.onChange(() => this._onResize());

    this.events.register(document.body, 'click', e => {
      if (!e.target.closest('[data-search-trigger], [data-search-flyout]')) {
        this._close();
      }
    });

    if (breakpoint.max('M')) {
      document.body.append(this.el);
    }

    if (this.settings.sticky_header === 'true' && breakpoint.min('L')) {
      this._onSticky();
    }

    // Offset the search form based on the width of the close button
    this.el.style.setProperty('--search-form-offset', `${this.formOffset}px`);
  }

  _onKeyUp(e) {
    if (e.code === 'Escape') {
      this.input.value = '';
      this._close();
    }
  }

  _onResize() {
    if (breakpoint.min('L')) {
      this.header.append(this.el);
    } else {
      document.body.append(this.el);
    }
  }

  _onSticky() {
    /*
      Loop through the sticky header elements to determine the highest maximum height,
      apply the highest maximum height to the search flyout container.
    */
    const stickyElements = document.querySelectorAll('[data-sticky-element]');
    const stickyElementHeights = Array.from(stickyElements).map(el => el.offsetHeight);
    const searchFlyoutHeight = Math.max(...stickyElementHeights);

    this.el.style.setProperty('--search-flyout-height', `${searchFlyoutHeight}px`);
  }

  _open() {
    if (this.isOpen) return;

    this.isOpen = true;

    this.animation.animateTo('open')
      .then(() => {
        const { length } = this.input.value;

        this.input.setSelectionRange(length, length);
        this.input.focus();

        ScrollLock.lock(this.el);

        this.siteOverlay.open();
      });
  }

  _close() {
    if (!this.isOpen) return;

    this.animation.animateTo('closed')
      .then(() => {
        this.isOpen = false;

        ScrollLock.unlock();

        this.siteOverlay.close();

        if (breakpoint.min('L')) {
          // Show the header controls when the search flyout is closed
          this.headerControls.style.zIndex = '901';
        }
      });
  }
}
